export type ContractStatus = 'DRAFT' | 'ACTIVE' | 'SUSPENDED' | 'EXPIRED' | 'TERMINATED';

export interface ContractStatusDisplay {
  label: string;
  variant: 'info' | 'success' | 'warning' | 'error' | 'default';
}

const STATUS_DISPLAY: Record<ContractStatus, ContractStatusDisplay> = {
  ACTIVE: { label: 'Active', variant: 'success' },
  DRAFT: { label: 'Draft', variant: 'info' },
  EXPIRED: { label: 'Expired', variant: 'warning' },
  SUSPENDED: { label: 'Suspended', variant: 'warning' },
  TERMINATED: { label: 'Terminated', variant: 'error' },
};

export function getContractStatusDisplay(status: string | undefined): ContractStatusDisplay {
  if (!status || !(status in STATUS_DISPLAY)) {
    return { label: status || 'Unknown', variant: 'default' };
  }

  return STATUS_DISPLAY[status as ContractStatus];
}

export function getContractStatusLabel(status: string | undefined): string {
  return getContractStatusDisplay(status).label;
}

export const CONTRACT_STATUS_FILTER_OPTIONS: { label: string; value: string }[] = [
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Expired', value: 'EXPIRED' },
  { label: 'Suspended', value: 'SUSPENDED' },
  { label: 'Draft', value: 'DRAFT' },
  { label: 'Terminated', value: 'TERMINATED' },
];
